import { z } from 'zod'

const doorRefSchema = z.object({ id: z.string(), name: z.string() })

export const RemoteLockConnectionSchema = z.object({
  authorizationCode: z.string().min(1, 'Authorization code is required'),
  shouldAutoAssignApartmentDoorVisitor: z.boolean(),
  staffDefaults: z.array(doorRefSchema),
  visitorDefaults: z.array(doorRefSchema),
})

export type RemoteLockConnectionFormValues = z.infer<typeof RemoteLockConnectionSchema>

export const remoteLockDefaultValues: RemoteLockConnectionFormValues = {
  authorizationCode: '',
  shouldAutoAssignApartmentDoorVisitor: false,
  staffDefaults: [],
  visitorDefaults: [],
}
